<template>
    <div class="userCenter">
        <div class="container clearfix">
            <div class="ucMenu">
                <p class="tit">个人中心</p>
                <ul>
                    <router-link to="/userPortrait" active-class="active"><li>用户画像</li></router-link>
                    <router-link to="/myResume" active-class="active"><li>我的简历</li></router-link>
                    <router-link to="/myApplyFor" active-class="active"><li>我的应聘</li></router-link>
                    <router-link to="/collection" active-class="active"><li>我的收藏</li></router-link>
                    <!--<router-link to="/account" active-class="active"><li>账号设置</li></router-link>-->
                </ul>
                <div class="tit2">
                    <p>推荐职位</p>
                    <p><span v-if="userSkill.length > 0">您已点亮大数据、人工智能技能！</span>看看适合您的职位吧！</p>
                </div>
                <ul class="recommendList">
                    <li v-for="job in recommendJobList" :key="job.id" @click="handleDetail(job)">
                        <p class="spaceBetween"><span>{{ job.positionName }}</span><span>{{ job.matchRate }}%</span></p>
                        <p>
                            {{ rangeFormatter(job) }}
                            <!-- 工作地点 -->
                            <el-divider direction="vertical"></el-divider>{{ job.enterpriseCity?job.enterpriseCity.join(""):'' }}<el-divider direction="vertical"></el-divider>
                            <!-- 学历要求 -->
                            {{ educationFormatter(job) }}
                        </p>
                        <div class="spaceBetween">
                            <img :src="imageLocation(job.logo)" alt="">
                            <div class="right">
                                <p>{{ job.enterpriseName }}</p>
                                <p class="tag"><i v-for="(item, index) in job.industry" :key="index">{{ item }}</i></p>
                            </div>
                        </div>
                    </li>
                </ul>
                <div class="buttons">
                    <el-button @click="handleMoreJob">查看更多职位</el-button>
                    <el-button @click="goMyResume">完善信息获得更多职位推荐</el-button>
                </div>

            </div>
            <div class="ucMain">
                <!--<resume></resume>-->
                <!--<account></account>-->
                <router-view></router-view>
            </div>
        </div>
    </div>
</template>
<script>
    import {findRecommendJob} from '@/api/job'
    import Resume from './components/Resume/index.vue';
    import Account from './Account';

    const YEAR_WAGES = 0;       // 年薪
    const MONTHLY_WAGES = 1;    // 月薪
    const DAILY_WAGES = 2;      // 日薪
    const HOURLY_WAGES = 3;     // 时薪
    const FACE_TO_FACE_WAGES = 4;     // 面议
    export default {
        name: "userCenter",
        data() {
            return {
                userSkill: [],
                recommendJobList: [],
                //学历集合
                educationOptions: [
                    {label: "不限", value: "NO_LIMIT"},
                    {label: "小学", value: "PRIMARY_SCHOOL"},
                    {label: "中学", value: "MIDDLE_SCHOOL"},
                    {label: "高中", value: "HIGH_SCHOOL"},
                    {label: "大专", value: "JUNIOR_COLLEGE"},
                    {label: "本科", value: "REGULAR_COLLEGE_COURSE"},
                    {label: "硕士", value: "MASTER"},
                    {label: "博士", value: "DOCTOR"},
                ]
            }
        },
        created() {
            if(!this.Cookies.get("TipDM-Login-Token")){
                // 跳转到登录页面
                window.location.href = '/login';
            }
            this.loadRecommendJob();
            this.getUserSkill();
            // this.$store.dispatch("userCenter/getUserSkill");
        },
        computed: {
            imageLocation(){
                return function (file){
                    let imagePath = encodeURI(file);
                    return `/files?imagePath=${imagePath}`;
                }
            },
        },
        methods: {
            /** 获取个人勋章 */
            getUserSkill(){
                this.userSkill = this.$store.state.userCenter.userSkill;
                if(!this.userSkill || this.userSkill.length == 0){
                    this.$store.dispatch("userCenter/getUserSkill").then((res) => {
                        this.userSkill = res.data;
                    });
                }
            },
            /** 学历格式化*/
            educationFormatter(row) {
                let item = this.educationOptions.find(x => x.value == row.educationalRequirements);
                return item ? item.label : '';
            },
            /** 薪资范围格式化*/
            rangeFormatter(row) {
                let msg = '';
                let min = row.minimumWage;
                let max = row.maximumWage;
                switch (row.payMethod) {
                    case YEAR_WAGES:
                        msg = min / 10000 + '-' + max / 10000 + 'W/年';
                        break;
                    case MONTHLY_WAGES:
                        msg = min / 1000 + '-' + max / 1000 + 'K/月';
                        break;
                    case DAILY_WAGES:
                        msg = min + '-' + max + '/日';
                        break;
                    case HOURLY_WAGES:
                        msg = min + '-' + max + '/时';
                        break;
                    case FACE_TO_FACE_WAGES:
                        msg = "面议";
                        break;
                }
                return msg;
            },
            goMyResume(){
                if(process.env.NODE_ENV == "development"){
                    window.location.href = window.location.origin + "/frontend#/myResume";
                }else{
                    window.location.href = window.location.origin + "/#/myResume";
                }
            },
            handleMoreJob(){
                if(process.env.NODE_ENV == "development"){
                    window.open(window.location.origin + "/frontend#/jobList");
                }else{
                    window.open(window.location.origin + "/#/jobList");
                }
            },
            // 打开职位详情
            handleDetail(job){
                if(process.env.NODE_ENV == "development"){
                    window.open(window.location.origin + "/frontend#/jobDetails/" + job.id);
                }else{
                    window.open(window.location.origin + "/#/jobDetails/" + job.id);
                }
            },
            // 获取推荐职位
            loadRecommendJob(){
                this.recommendJobList = this.$store.state.userCenter.recommendJobList;
                if(!this.recommendJobList || this.recommendJobList.length == 0){
                    this.$store.dispatch("userCenter/getRecommendJobList").then((res) => {
                        this.recommendJobList = res.data;
                    });
                }
            }
        },
        components: {
            Account,
            Resume
        },
    }
</script>
